import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/admin/settings", label: "AI settings" },
  { to: "/admin/ai-costs", label: "AI costs" },
  { to: "/admin/signups", label: "Sign-ups" },
  { to: "/admin/waitlist", label: "Access requests" },
];

export function AdminNav() {
  return (
    <nav className="mb-6 flex gap-1 border-b border-line" aria-label="Admin sections">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            `border-b-2 px-3 py-2 text-sm font-medium no-underline ${isActive ? "border-brand-600 text-brand-700" : "border-transparent text-muted hover:text-ink"}`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
